// extracted by mini-css-extract-plugin
export default {"wrapper":"AppBar_wrapper__NvAif","btn-clear":"AppBar_btn-clear__gLdE9","dark":"AppBar_dark__AV7Py"};